(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const social = document.querySelector(".footer__social");

  const isReduced =
    window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
    window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

  if (!isReduced) {
    social.addEventListener("mouseenter", (event) => {
      social.classList.add("active");
    });

    social.addEventListener("mouseleave", (event) => {
      social.classList.remove("active");
    });
  }

  const collapsibleWrapper = document.querySelector(".footer__wrapper[data-collapsible]");
  const footerToggle = document.querySelector(".footer-toggle");

  if (collapsibleWrapper && footerToggle) {
    const footer = collapsibleWrapper.querySelector(".footer");

    footerToggle.addEventListener("click", function () {
      const isActive = collapsibleWrapper.classList.toggle("active");
      footerToggle.setAttribute("aria-expanded", String(isActive));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function toggleMenu() {
    const topNav = document.querySelector(".top-nav");
    const navOverlay = document.querySelector(".nav-overlay");

    topNav.classList.toggle("active");
    navOverlay.classList.toggle("active");
  }
  window.toggleMenu = toggleMenu;

  } catch(e) { console.error(e); }
})();
})();
